import validate from "/usr/src/app/content/n3-promos-57f8afe6-cab4-43ef-bfdb-33494787dff1/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-57f8afe6-cab4-43ef-bfdb-33494787dff1/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}